<script>
import ElCarousel from 'element-ui/packages/carousel/src/main'

export default {
  // 子项直接读取父级并按 ElCarouselItem 筛选，不能增加中间包装实例。
  name: 'ElCarousel',
  extends: ElCarousel,
  render (h) {
    const vnode = ElCarousel.render.call(this, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-carousel']
    return vnode
  }
}
</script>
